import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CheckoutStatusPoller } from '../services/checkout-status-poller';
import { NoopScrollStrategy } from '@angular/cdk/overlay';



export type PurchaseResultDialogData = {
  purchaseResult: "SUCCESS" | "FAILED",
  checkoutId?: string
}

@Component({
    selector: 'app-purchase-result-dialog',
    templateUrl: './purchase-result-dialog.component.html',
    styleUrls: ['./purchase-result-dialog.component.scss'],
    standalone: false
})
export class PurchaseResultDialogComponent implements OnInit {
  loading: boolean = false;
  syncStatus: {status: "PENDING" | "PROCEED" | "FAILED" | "TIMEOUT"} = {status: "PENDING"};
  text!:string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:{ purchaseResult:"SUCCESS"|"FAILED", checkoutId: string },
    private checkoutStatusPoller: CheckoutStatusPoller
  ) { }

  ngOnInit(): void {
    this.init()
  }

  static openDialog(dialog: MatDialog, data: PurchaseResultDialogData): MatDialogRef<PurchaseResultDialogComponent> {
    return dialog.open(PurchaseResultDialogComponent, {
      data: data,
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'invisible-backdrop',
      scrollStrategy: new NoopScrollStrategy()
    });
  }

  async init(): Promise<void> {
    if(this.data.purchaseResult === "SUCCESS"){
      this.loading = true;
      this.syncStatus = await this.checkoutStatusPoller.checkStatus(this.data.checkoutId);
      this.loading = false;

      if(this.syncStatus.status === "FAILED" || this.syncStatus.status == "TIMEOUT"){
        this.text = "Hívd az ügyfélszolgálatot!";
      }
      if(this.syncStatus.status == "PROCEED"){
        this.text = "Sikeres vásárlás";
      }
    }else{
      this.text = "Sikertelen vásárlás";
    }
  }

}
